export const cellSizeForZoom = (zoom) => {
  if (zoom >= 15) return 0;
  if (zoom >= 13) return 0.006;
  if (zoom >= 11) return 0.018;
  return 0.045;
};

export const bucketPins = (pins, zoom) => {
  const cellSize = cellSizeForZoom(zoom);
  if (!cellSize) {
    return pins.map((pin) => ({ type: 'pin', pin }));
  }

  const buckets = new Map();
  pins.forEach((pin) => {
    const cellLat = Math.floor(pin.lat / cellSize);
    const cellLng = Math.floor(pin.lng / cellSize);
    const key = `${cellLat},${cellLng}`;
    if (!buckets.has(key)) buckets.set(key, []);
    buckets.get(key).push(pin);
  });

  const result = [];
  buckets.forEach((bucket) => {
    if (bucket.length === 1) {
      result.push({ type: 'pin', pin: bucket[0] });
      return;
    }
    const lat = bucket.reduce((sum, p) => sum + p.lat, 0) / bucket.length;
    const lng = bucket.reduce((sum, p) => sum + p.lng, 0) / bucket.length;
    result.push({ type: 'cluster', lat, lng, pins: bucket, count: bucket.length });
  });
  return result;
};

export const cityOverviewZoom = (pinCount) => {
  if (pinCount > 80) return 10;
  if (pinCount > 30) return 11;
  if (pinCount > 12) return 12;
  return 13;
};
